import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import HeaderFour from "../../components/Header/HeaderFour";
import Footer from "../../components/Footer";
import Seo from "../../components/Seo";
import config from "../../config";
import makeRequest from "../../makeRequest";

const STYLE_ID = "career-detail-styles";

const injectStyles = () => {
  if (document.getElementById(STYLE_ID)) return;
  const style = document.createElement("style");
  style.id = STYLE_ID;
  style.textContent = `
    .cd-hero {
      background: linear-gradient(135deg, #0d1f3c 0%, #1a4a7a 60%, #0d9e8a 100%);
      color: #fff;
      padding: 60px 0 50px;
    }
    .cd-hero-inner {
      display: flex;
      gap: 40px;
      align-items: flex-start;
    }
    .cd-hero-image {
      width: 200px;
      height: 140px;
      border-radius: 14px;
      object-fit: cover;
      flex-shrink: 0;
      border: 3px solid rgba(255,255,255,0.25);
    }
    .cd-hero-placeholder {
      width: 200px;
      height: 140px;
      border-radius: 14px;
      background: rgba(255,255,255,0.12);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 3rem;
      flex-shrink: 0;
    }
    .cd-hero-title { font-size: 2.2rem; font-weight: 800; margin-bottom: 10px; }
    .cd-hero-name { font-size: 1rem; opacity: 0.7; margin-bottom: 16px; }
    .cd-hero-badges { display: flex; gap: 10px; flex-wrap: wrap; }
    .cd-badge {
      display: inline-flex; align-items: center; gap: 6px;
      background: rgba(255,255,255,0.15); border: 1px solid rgba(255,255,255,0.25);
      border-radius: 20px; padding: 5px 14px; font-size: 0.82rem; font-weight: 600;
    }
    .cd-badge-deadline { background: rgba(255,100,100,0.25); border-color: rgba(255,100,100,0.4); }
    .cd-section { padding: 60px 0 80px; background: #f8f9fa; }
    .cd-layout { display: grid; grid-template-columns: 1fr 380px; gap: 36px; align-items: start; }
    .cd-content-card {
      background: #fff; border-radius: 16px; padding: 32px;
      box-shadow: 0 4px 24px rgba(13,31,60,0.07);
    }
    .cd-content-card + .cd-content-card { margin-top: 24px; }
    .cd-card-title {
      font-size: 1.15rem; font-weight: 700; color: #1a2e4a;
      margin-bottom: 18px; padding-bottom: 12px;
      border-bottom: 2px solid #f0f4f8; display: flex; align-items: center; gap: 10px;
    }
    .cd-html-content { font-size: 0.94rem; color: #3a4a5c; line-height: 1.75; }
    .cd-html-content ul, .cd-html-content ol { padding-left: 20px; margin: 8px 0; }
    .cd-html-content p { margin-bottom: 10px; }
    .cd-html-content h1,.cd-html-content h2,.cd-html-content h3 { color: #1a2e4a; margin: 16px 0 8px; }
    .cd-sidebar-card {
      background: #fff; border-radius: 16px; padding: 28px;
      box-shadow: 0 4px 24px rgba(13,31,60,0.07);
      position: sticky; top: 20px;
    }
    .cd-sidebar-title { font-size: 1.05rem; font-weight: 700; color: #1a2e4a; margin-bottom: 18px; }
    .cd-meta-list { display: flex; flex-direction: column; gap: 12px; margin-bottom: 24px; }
    .cd-meta-item { display: flex; gap: 12px; align-items: flex-start; font-size: 0.88rem; color: #4a6080; }
    .cd-meta-label { font-weight: 600; color: #1a2e4a; min-width: 80px; }
    .cd-divider { border: none; border-top: 1px solid #f0f4f8; margin: 20px 0; }
    /* Apply Form */
    .cd-apply-section { margin-top: 0; }
    .cd-apply-title { font-size: 1.3rem; font-weight: 700; color: #1a2e4a; margin-bottom: 20px; display: flex; align-items: center; gap: 10px; }
    .cd-form-group { display: flex; flex-direction: column; gap: 5px; margin-bottom: 14px; }
    .cd-form-label { font-size: 0.85rem; font-weight: 600; color: #4a6080; }
    .cd-form-label span { color: #e74c3c; margin-left: 2px; }
    .cd-form-input {
      padding: 11px 16px; border: 2px solid #e0e7ef; border-radius: 10px;
      font-size: 0.9rem; outline: none; transition: border-color 0.2s;
      background: #f8f9fa;
    }
    .cd-form-input:focus { border-color: #1a4a7a; background: #fff; }
    .cd-form-input.error { border-color: #e74c3c; }
    .cd-form-textarea { resize: vertical; min-height: 90px; }
    .cd-form-file-label {
      padding: 20px; border: 2px dashed #e0e7ef; border-radius: 10px;
      text-align: center; cursor: pointer; transition: border-color 0.2s; font-size: 0.88rem; color: #7a8da0;
      background: #f8f9fa;
    }
    .cd-form-file-label:hover { border-color: #1a4a7a; color: #1a4a7a; }
    .cd-form-file-label.has-file { border-color: #0d9e8a; color: #0d9e8a; background: #f0fdf9; }
    .cd-error-msg { font-size: 0.8rem; color: #e74c3c; }
    .cd-submit-btn {
      width: 100%; padding: 13px; background: linear-gradient(135deg, #1a4a7a, #0d9e8a);
      color: #fff; border: none; border-radius: 50px; font-size: 1rem; font-weight: 700;
      cursor: pointer; transition: opacity 0.2s; margin-top: 6px;
    }
    .cd-submit-btn:hover:not(:disabled) { opacity: 0.88; }
    .cd-submit-btn:disabled { opacity: 0.55; cursor: not-allowed; }
    .cd-alert {
      padding: 14px 18px; border-radius: 10px; font-size: 0.9rem; font-weight: 600; margin-bottom: 16px;
    }
    .cd-alert-error { background: #ffe5e5; color: #c0392b; border: 1px solid #f5c6cb; }
    .cd-alert-success { background: #d4edda; color: #155724; border: 1px solid #c3e6cb; }
    .cd-back-link { display: inline-flex; align-items: center; gap: 8px; color: #1a4a7a; font-weight: 600; text-decoration: none; margin-bottom: 20px; font-size: 0.9rem; }
    .cd-back-link:hover { text-decoration: underline; }
    @media (max-width: 900px) {
      .cd-layout { grid-template-columns: 1fr; }
      .cd-sidebar-card { position: static; }
      .cd-hero-inner { flex-direction: column; }
      .cd-hero-image, .cd-hero-placeholder { width: 100%; height: 200px; }
    }
  `;
  document.head.appendChild(style);
};

const badgeTypeClass = (t) => {
  const map = { "Full-time": "#27ae60", "Part-time": "#2980b9", Contract: "#e67e22", Internship: "#8e44ad" };
  return map[t] || "#7a8da0";
};

function CareerDetail() {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    injectStyles();
  }, []);

  const [job, setJob] = useState(null);
  const [imageSrc, setImageSrc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({ applicantName: "", email: "", phone: "", cnic: "", coverLetter: "" });
  const [resumeFile, setResumeFile] = useState(null);
  const [resumeBase64, setResumeBase64] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [formError, setFormError] = useState("");
  const [formSuccess, setFormSuccess] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});

  useEffect(() => {
    makeRequest({ route: `/website/career/${id}/detail`, method: "get" })
      .then((res) => setJob(res?.data || res))
      .catch(() => navigate("/careers"))
      .finally(() => setLoading(false));
  }, [id, navigate]);

  useEffect(() => {
    if (!job) return;
    let objectUrl = null;
    let cancelled = false;
    if (job.hasImage) {
      fetch(`${config.api.baseUrl}/website/career/${id}/image`)
        .then((r) => r.blob())
        .then((b) => {
          if (!cancelled) {
            objectUrl = URL.createObjectURL(b);
            setImageSrc(objectUrl);
          }
        })
        .catch(() => {});
    }
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [job, id]);

  const handleResumeSelect = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.type !== "application/pdf") {
      setFormError("Resume must be a PDF file.");
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      setFormError("Resume PDF must be under 5 MB.");
      return;
    }
    setFormError("");
    setResumeFile(file);
    const reader = new FileReader();
    reader.onload = () => setResumeBase64(reader.result);
    reader.readAsDataURL(file);
  };

  const validate = () => {
    const errors = {};
    if (!formData.applicantName.trim()) errors.applicantName = "Name is required";
    if (!formData.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) errors.email = "Valid email is required";
    if (!formData.phone.trim()) errors.phone = "Phone is required";
    if (!formData.cnic.trim()) errors.cnic = "CNIC is required";
    setFieldErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormError("");
    if (!validate()) return;
    try {
      setSubmitting(true);
      const payload = { careerId: parseInt(id), ...formData };
      if (resumeBase64) payload.resumePdf = resumeBase64;
      await makeRequest({ route: "/website/career-application", method: "post", data: payload });
      setFormSuccess(true);
    } catch (err) {
      const status = err?.response?.status || err?.status;
      if (status === 409) {
        setFormError("You have already applied for this position with this CNIC. Only one application per CNIC is allowed.");
      } else {
        setFormError(err?.message || "Failed to submit application. Please try again.");
      }
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <>
        <HeaderFour />
        <div style={{ textAlign: "center", padding: "120px 20px", color: "#8ea3bb" }}>
          <p>Loading job details...</p>
        </div>
        <Footer />
      </>
    );
  }

  if (!job) return null;

  const expired = job.deadline && new Date(job.deadline) < new Date();

  return (
    <>
      <Seo title={`${job.title || job.name} | Careers | Maroof International Hospital`} />
      <HeaderFour />

      <div className="cd-hero">
        <div className="container">
          <div className="cd-hero-inner">
            {imageSrc ? (
              <img src={imageSrc} alt={job.title || job.name} className="cd-hero-image" />
            ) : (
              <div className="cd-hero-placeholder">🏥</div>
            )}
            <div>
              <div className="cd-hero-title">{job.title || job.name}</div>
              {job.title && job.name !== job.title && <div className="cd-hero-name">{job.name}</div>}
              <div className="cd-hero-badges">
                {job.jobType && <span className="cd-badge">{job.jobType}</span>}
                {job.location && <span className="cd-badge">📍 {job.location}</span>}
                {job.experience && <span className="cd-badge">⏱ {job.experience}</span>}
                {job.salaryRange && <span className="cd-badge">💵 {job.salaryRange}</span>}
                {job.deadline && (
                  <span className={`cd-badge${expired ? " cd-badge-deadline" : ""}`}>
                    🗓{" "}
                    {expired
                      ? "Expired"
                      : `Deadline: ${new Date(job.deadline).toLocaleDateString("en-PK", { day: "numeric", month: "long", year: "numeric" })}`}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="cd-section">
        <div className="container">
          <Link to="/careers" className="cd-back-link">
            ← Back to All Positions
          </Link>
          <div className="cd-layout">
            {/* Left column */}
            <div>
              {job.description && (
                <div className="cd-content-card">
                  <div className="cd-card-title">📋 About This Role</div>
                  <p style={{ fontSize: "0.95rem", color: "#3a4a5c", lineHeight: 1.75 }}>{job.description}</p>
                </div>
              )}
              {job.jobDescription && (
                <div className="cd-content-card">
                  <div className="cd-card-title">📄 Job Description</div>
                  <div className="cd-html-content" dangerouslySetInnerHTML={{ __html: job.jobDescription }} />
                </div>
              )}
              {job.requirements && (
                <div className="cd-content-card">
                  <div className="cd-card-title">✅ Requirements</div>
                  <div className="cd-html-content" dangerouslySetInnerHTML={{ __html: job.requirements }} />
                </div>
              )}
              {job.skills && (
                <div className="cd-content-card">
                  <div className="cd-card-title">🛠 Required Skills</div>
                  <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                    {job.skills.split(",").map(
                      (s, i) =>
                        s.trim() && (
                          <span
                            key={i}
                            style={{
                              background: "#e8f0fe",
                              color: "#1a4a7a",
                              padding: "5px 14px",
                              borderRadius: "20px",
                              fontSize: "0.85rem",
                              fontWeight: 600,
                            }}
                          >
                            {s.trim()}
                          </span>
                        ),
                    )}
                  </div>
                </div>
              )}
            </div>

            {/* Right sidebar */}
            <div>
              <div className="cd-sidebar-card">
                <div className="cd-sidebar-title">Job Details</div>
                <div className="cd-meta-list">
                  {job.jobType && (
                    <div className="cd-meta-item">
                      <span className="cd-meta-label">Type</span>
                      <span style={{ background: "#f0f4f8", padding: "3px 12px", borderRadius: "20px", fontWeight: 600, fontSize: "0.85rem" }}>
                        {job.jobType}
                      </span>
                    </div>
                  )}
                  {job.location && (
                    <div className="cd-meta-item">
                      <span className="cd-meta-label">Location</span>
                      <span>{job.location}</span>
                    </div>
                  )}
                  {job.experience && (
                    <div className="cd-meta-item">
                      <span className="cd-meta-label">Experience</span>
                      <span>{job.experience}</span>
                    </div>
                  )}
                  {job.salaryRange && (
                    <div className="cd-meta-item">
                      <span className="cd-meta-label">Salary</span>
                      <span>{job.salaryRange}</span>
                    </div>
                  )}
                  {job.deadline && (
                    <div className="cd-meta-item">
                      <span className="cd-meta-label">Deadline</span>
                      <span style={{ color: expired ? "#e74c3c" : "#0d7a6a", fontWeight: 600 }}>
                        {new Date(job.deadline).toLocaleDateString("en-PK", { day: "numeric", month: "long", year: "numeric" })}
                      </span>
                    </div>
                  )}
                </div>

                <hr className="cd-divider" />

                <div className="cd-apply-section">
                  <div className="cd-apply-title">✉ Apply Now</div>

                  {expired ? (
                    <div className="cd-alert cd-alert-error">This position is no longer accepting applications.</div>
                  ) : formSuccess ? (
                    <div className="cd-alert cd-alert-success">
                      🎉 Application submitted successfully!
                      <br />
                      <span style={{ fontSize: "0.85rem", fontWeight: 400 }}>We'll review your application and contact you soon.</span>
                    </div>
                  ) : (
                    <form onSubmit={handleSubmit} noValidate>
                      {formError && <div className="cd-alert cd-alert-error">{formError}</div>}
                      {[
                        { name: "applicantName", label: "Full Name", type: "text", placeholder: "Your full name", required: true },
                        { name: "email", label: "Email Address", type: "email", placeholder: "your@email.com", required: true },
                        { name: "phone", label: "Phone Number", type: "tel", placeholder: "+92 3XX XXXXXXX", required: true },
                        {
                          name: "cnic",
                          label: "CNIC Number",
                          type: "text",
                          placeholder: "XXXXX-XXXXXXX-X",
                          required: true,
                          hint: "Used to prevent duplicate applications",
                        },
                      ].map(({ name, label, type, placeholder, required, hint }) => (
                        <div key={name} className="cd-form-group">
                          <label className="cd-form-label">
                            {label}
                            {required && <span>*</span>}
                          </label>
                          <input
                            type={type}
                            className={`cd-form-input${fieldErrors[name] ? " error" : ""}`}
                            placeholder={placeholder}
                            value={formData[name]}
                            onChange={(e) => setFormData((p) => ({ ...p, [name]: e.target.value }))}
                          />
                          {fieldErrors[name] && <span className="cd-error-msg">{fieldErrors[name]}</span>}
                          {hint && !fieldErrors[name] && <span style={{ fontSize: "0.77rem", color: "#8ea3bb" }}>{hint}</span>}
                        </div>
                      ))}

                      <div className="cd-form-group">
                        <label className="cd-form-label">Cover Letter (optional)</label>
                        <textarea
                          className="cd-form-input cd-form-textarea"
                          placeholder="Tell us why you are a great fit for this role..."
                          value={formData.coverLetter}
                          onChange={(e) => setFormData((p) => ({ ...p, coverLetter: e.target.value }))}
                        />
                      </div>

                      <div className="cd-form-group">
                        <label className="cd-form-label">Resume (PDF, max 5 MB)</label>
                        <label className={`cd-form-file-label${resumeFile ? " has-file" : ""}`}>
                          {resumeFile ? `✓ ${resumeFile.name}` : "Click to upload PDF resume"}
                          <input type="file" accept="application/pdf" hidden onChange={handleResumeSelect} />
                        </label>
                      </div>

                      <button type="submit" className="cd-submit-btn" disabled={submitting}>
                        {submitting ? "Submitting..." : "Submit Application"}
                      </button>
                    </form>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default CareerDetail;
